var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    on: {
      "click": _vm.hide
    }
  }, [_c('div', {
    staticClass: "g_pop_share_spm"
  }, [_c('div', {
    staticClass: "pop_wrap"
  }, [_c('div', {
    staticClass: "pop_con"
  }, [_c('img', {
    attrs: {
      "src": _vm.promptImg,
      "alt": ""
    }
  })])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };